import * as React from 'react';
import IToolTip from './IToolTip';

import * as style from './ToolTipStyle.module.scss'

export default class ToolTip extends React.Component<IToolTip> {
  private tooltipParagraphRef: React.RefObject<HTMLParagraphElement>;
  constructor(props: IToolTip) {
    super(props);
    this.tooltipParagraphRef = React.createRef<HTMLParagraphElement>();
  }

  mouseMove = (e: React.MouseEvent) => {
    const node = this.tooltipParagraphRef.current;

    if (node) {
      node.style.left = Math.max(0, e.clientX - node.offsetWidth / 2) + 'px';
      node.style.top = e.clientY - node.offsetHeight - 25 + 'px';
    }
  }

  render() {
    const { maxWidth, className } = this.props;

    return (
      <div className={[style.tooltip, className].join(' ')} onMouseMove={this.mouseMove} onClick={this.mouseMove}>
        <p
          ref={this.tooltipParagraphRef}
          className={style.info}
          style={maxWidth ? { maxWidth: maxWidth } : undefined}
        >
          {this.props.text}
        </p>
        {this.props.children}
      </div>
    );
  }
}
